// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M16.275.028a.806.806 0 0 0-.467.427.661.661 0 0 0-.05.289c0 .308.16.559.442.693l.132.063 2.543.007 2.543.007-6.878 6.88c-3.784 3.785-6.907 6.927-6.94 6.982a.793.793 0 0 0-.006.738.966.966 0 0 0 .322.312c.179.092.482.088.68-.01.074-.038 2.05-1.998 6.997-6.943l6.894-6.891.006 2.543.007 2.543.063.132c.08.168.214.302.381.38.106.05.167.062.312.061a.676.676 0 0 0 .49-.178c.094-.083.225-.289.236-.371.003-.026.012 3.176.02 7.116.011 5.66.013 4.922.008-3.517L24.003.61l-.05-.136a.784.784 0 0 0-.398-.416L23.423 0l-3.534.002c-2.197.002-3.564.011-3.614.026M1.968 4.514c-.207.024-.534.12-.708.208A2.33 2.33 0 0 0 .07 6.185c-.045.18-.046.334-.046 8.059 0 7.81 0 7.878.048 8.066.056.22.195.522.333.725.283.418.78.761 1.299.899l.204.054h15.696l.202-.055c.821-.225 1.416-.828 1.64-1.666l.053-.199.007-4.644c.006-3.345 0-4.689-.02-4.805a.775.775 0 0 0-.534-.597.877.877 0 0 0-.524.048.909.909 0 0 0-.36.362l-.056.108L18 17.232l-.012 4.692-.055.122a.865.865 0 0 1-.365.374l-.108.056-7.673.006-7.672.006-.135-.05a.766.766 0 0 1-.418-.418l-.05-.134v-7.639c0-8.601-.02-7.758.194-7.993a.825.825 0 0 1 .244-.185l.126-.057L6.768 6l4.692-.012.12-.064a.816.816 0 0 0 .362-.389c.056-.123.063-.162.053-.324-.017-.299-.167-.518-.45-.657l-.109-.054-4.644-.003c-2.554-.002-4.725.006-4.824.017"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const ExpandIcon = Icon;
export default ExpandIcon;
